import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "block",
  },
  entryTime: { width: "100%" },
  submitBtn: { float: "right", marginTop: theme.spacing(1) },
}));
